import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import AppContainer from "../Structure/AppContainer";
import AuthContext from "../../Context/AuthContext";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ajaxSupplierInvoices from "../../util/remote/ajaxSupplierInvoices";
import SupplierInvoiceDetailsModal from "./SupplierInvoiceDetailsModal";
import Loader from "../Common/Loader";
import SystemModal from "../Common/SystemModal";
import AddInvoicePartialPayment from "./AddInvoicePartialPayment";
import ajaxSupplierInvoicesPayments from "../../util/remote/ajaxSupplierInvoicesPayments";
const ConfirmSupplierPayments = () => {
  const { userId } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [view_details, setView_details] = useStateCallback(false);
  // Fetch invoices ready for payments
  const fetchSupplierInvoices = async () => {
    setLoading(true);
    setInvoices([]);
    const server_response =
      await ajaxSupplierInvoices.fetchSupplierInvoices_4_payments({});
    setLoading(false);
    if (server_response.status === "OK") {
      const pendingInvoices = server_response.details.filter(
        (inv) => parseFloat(inv.balance) > 0
      );
      setInvoices(pendingInvoices);
    } else {
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetchSupplierInvoices();
  }, []);
  // View invoice details modal
  const handleView_details = (invoiceId) => {
    setView_details(false, () =>
      setView_details(<SupplierInvoiceDetailsModal invoiceId={invoiceId} />)
    );
  };
  const [partial, setPartial] = useStateCallback(false);
  const handleAddPartialPayment = (invoiceId) => {
    setPartial(false, () =>
      setPartial(
        <AddInvoicePartialPayment
          invoiceId={invoiceId}
          func={fetchSupplierInvoices}
        />
      )
    );
  };
  // ✅ Confirm complete payment
  const handleConfirmCompletePayment = async (invoiceId, balance) => {
    const confirmAction = window.confirm(
      "Confirm marking this invoice as fully paid?"
    );
    if (!confirmAction) return;
    setLoading(true);
    const data = {
      InvoiceID: invoiceId,
      amount: balance,
      // payment_date: paymentDate,
      date_created: new Date().toISOString().split("T")[0],
      created_by: userId,
    };
    const response = await ajaxSupplierInvoicesPayments.createSupplierPayment(
      data
    );
    setLoading(false);
    if (response.status === "OK") {
      toast.success("Invoice fully paid successfully!");
      fetchSupplierInvoices();
    } else {
      toast.error(response.message || "Failed to confirm payment");
    }
  };
  // 💰 Open partial payment modal
  return (
    <AppContainer title="Invoices ready for payments">
      <div className="container-fluid">
        <Toaster />
        {loading && <Loader />}
        {view_details}
        {/* Partial Payment Modal */}
        {partial}
        {/* Table */}
        <div className="card shadow-sm border-0">
          <div className="card-header bg-light fw-bold">
            <i className="fa fa-list me-2"></i> Organisation Supplier Invoices
            Ready for Payments
          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Invoice No</th>
                    <th>Delivery Reff</th>
                    <th>Supplier</th>
                    <th>Contact</th>
                    <th>Amount</th>
                    <th>Balance</th>
                    <th>Date</th>
                    <th>Created By</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(invoices) && invoices.length > 0 ? (
                    invoices.map((inv, key) => (
                      <tr key={inv.id}>
                        <td>{key + 1}</td>
                        <td>
                          {inv.invoice_no}
                          <br />
                          <button
                            className="btn btn-sm btn-outline-primary mb-1"
                            onClick={() => handleView_details(inv.id)}
                          >
                            <i className="fa fa-eye"></i> details
                          </button>
                        </td>
                        <td>{inv.delievery_reff_no}</td>
                        <td>{inv.buss_name}</td>
                        <td>{inv.buss_contact}</td>
                        <td>{parseFloat(inv.amount).toLocaleString()}</td>
                        <td>
                          <span className="badge bg-warning text-dark">
                            {parseFloat(inv.balance).toLocaleString()}
                          </span>
                        </td>
                        <td>{inv.date_created}</td>
                        <td>{inv.created_by}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-sm btn-outline-primary mb-1"
                            onClick={() =>
                              handleConfirmCompletePayment(inv.id, inv.balance)
                            }
                          >
                            full payment
                          </button>
                          <br />
                          <button
                            className="btn btn-sm btn-outline-warning"
                            onClick={() => handleAddPartialPayment(inv.id)}
                          >
                            add_partial
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center py-3">
                        {loading
                          ? "Loading invoices..."
                          : "No pending invoices found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};
export default ConfirmSupplierPayments;
